import {
  Component,
  Input,
  ElementRef,
  QueryList,
  ViewChildren,
  AfterViewInit,
  HostListener,
  OnChanges,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'app-url-breadcrumb',
  templateUrl: './url-breadcrumb.component.html',
  standalone: false,
})
export class UrlBreadcrumbComponent implements OnChanges, AfterViewInit {
  @Input() url: string = '';
  segments: string[] = [];
  hiddenFlag = false;
  visibleCount = 0;
  hiddenSegments: string[] = [];

  @ViewChildren('crumbRef') crumbRefs!: QueryList<ElementRef>;
  @ViewChildren('containerRef') containerRef!: QueryList<ElementRef>;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges() {
    let cleanedUrl = this.url.replace(/^https?:\/\//, '').split(/[?#]/)[0];
    const parts = cleanedUrl.split('/');
    parts.shift();
    this.segments = parts.filter(Boolean);
    this.visibleCount = this.segments.length;
    this.updateHiddenSegments();
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
    this.measureCrumbs();
  }

  @HostListener('window:resize')
  onResize() {
    this.measureCrumbs();
  }

  measureCrumbs() {
    const container = this.containerRef.first?.nativeElement;
    if (!container || !this.crumbRefs?.length) return;
    let total = 0;
    let fit = 0;
    const children = Array.from(container.children);
    for (let i = 0; i < children.length; i++) {
      total += (children[i] as HTMLElement).offsetWidth;
      if (total > container.offsetWidth) {
        this.hiddenFlag = true;
        break;
      }
      fit++;
    }
    this.visibleCount = fit;
    this.updateHiddenSegments();
  }

  private updateHiddenSegments() {
    this.hiddenSegments = this.segments.slice(this.visibleCount);
  }
  capitalizeFirstLetter(segment: string): string {
    if (!segment) return '';
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  }
}
